import styled from 'glamorous'
import { $ } from 'utils'

const ListInfo = styled.div({
  padding: '15px 0',
  borderBottom: '1px solid var(--borderColor)',
}, ({ last, isHoverable }) => ({
  ...last && {
    paddingBottom: 0,
    borderBottom: 'none'
  },
  ...isHoverable && {
    cursor: 'pointer'
  }
}))

const ListName = styled.div({
  fontWeight: 'bold',
  marginBottom: 5,
})

const ListValue = styled.div({
  color: 'var(--grey)',
  fontSize: 14,
})

const ListItem = ({ name, value, last, isHoverable, onClick }) =>
    $(ListInfo, { last, isHoverable, onClick },
      $(ListName, name),
      $(ListValue, value),
    )

export default ListItem



// WEBPACK FOOTER //
// ./src/components/ListItem.js